import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Действие, навешанное на ту или иную кнопку панели инструментов. */
let DxGridToolbarAction = class DxGridToolbarAction {
    constructor(fields) {
        /**
         * Обусловлена ли возможность выполнения действия наличием одной и только одной выбранной строки в гриде.
         */
        this._isSingleRowAction = false;
        /**
         * Обусловлена ли возможность выполнения действия наличием нескольких выбранных строк в гриде.
         */
        this._isMultiRowAction = false;
        /**
         * Признак того что действие не зависит от наличия выделения.
         */
        this._isSelectionIndependent = false;
        // TODO: Придумать для этого флага название по-лучше! Пока у меня фонтазия иссякла :(
        /**
         * Возможность выполнения действия должна определятся при появлении выделения,
         * путем прогона критериев для каждого элемента выделения.
         */
        this._isSelectionDependent = false;
        if (fields) {
            Object.assign(this, fields);
        }
    }
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    get isSingleRowAction() {
        return this._isSingleRowAction;
    }
    set isSingleRowAction(value) {
        this._isSingleRowAction = value;
    }
    get isMultiRowAction() {
        return this._isMultiRowAction;
    }
    set isMultiRowAction(value) {
        this._isMultiRowAction = value;
    }
    get isSelectionIndependent() {
        return this._isSelectionIndependent;
    }
    set isSelectionIndependent(value) {
        this._isSelectionIndependent = value;
    }
    get isSelectionDependent() {
        return this._isSelectionDependent;
    }
    set isSelectionDependent(value) {
        this._isSelectionDependent = value;
    }
    get args() {
        return this._args;
    }
    set args(value) {
        this._args = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "type", constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxGridToolbarAction.prototype, "_type", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSingleRowAction", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridToolbarAction.prototype, "_isSingleRowAction", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isMultiRowAction", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridToolbarAction.prototype, "_isMultiRowAction", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSelectionIndependent", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridToolbarAction.prototype, "_isSelectionIndependent", void 0);
tslib_1.__decorate([
    jsonMember({ name: "isSelectionDependent", constructor: Boolean, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], DxGridToolbarAction.prototype, "_isSelectionDependent", void 0);
DxGridToolbarAction = tslib_1.__decorate([
    jsonObject,
    tslib_1.__metadata("design:paramtypes", [Object])
], DxGridToolbarAction);
export { DxGridToolbarAction };
